<template>
  <section class="salon-promo">

    <div class="salon-promo__pricing">
      <div class="salon-promo__pricing-line">Style Cuts from</div>
      <div class="salon-promo__pricing-amount">$35</div>
      <div class="salon-promo__pricing-sub">Plus pricing for Seniors, Students &amp; Children.</div>
    </div>

    <div class="salon-promo__grid">

      <div class="salon-promo__card">
        <div class="salon-promo__icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none"  stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="9" />
            <polyline points="12,7 12,12 15,14" />
          </svg>
        </div>
        <h3 class="salon-promo__card-title">No Appointments</h3>
        <p class="salon-promo__card-text">Just walk in, seven days a week.</p>
      </div>

      <div class="salon-promo__card">
        <div class="salon-promo__icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
            <polygon points="12,3 14.6,8.6 21,9.3 16.5,13.7 17.7,20 12,16.9 6.3,20 7.5,13.7 3,9.3 9.4,8.6" />
          </svg>
        </div>
        <h3 class="salon-promo__card-title">Expert Qualified Stylists</h3>
        <p class="salon-promo__card-text">Trained, accredited and continually upskilled.</p>
      </div>

      <div class="salon-promo__card">
        <div class="salon-promo__icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
            <path d="M12 3 L4 6 V12 C4 17 8 20.5 12 21 C16 20.5 20 17 20 12 V6 Z" />
            <polyline points="9,12 11.5,14.5 16,10" />
          </svg>
        </div>
        <h3 class="salon-promo__card-title">7-Day Guarantee</h3>
        <p class="salon-promo__card-text">Not happy? Return within 7 days and our Stylists will adjust to meet your expectations.</p>
      </div>

      <div class="salon-promo__card">
        <div class="salon-promo__icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none"  stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="9" />
            <line x1="12" y1="8" x2="12" y2="16" />
            <line x1="8" y1="12" x2="16" y2="12" />
          </svg>
        </div>
        <h3 class="salon-promo__card-title">Value Extras</h3>
        <p class="salon-promo__card-text">Add a shampoo, scalp massage, treatment, blow dry or beard trim to your service.</p>
      </div>

    </div>

    <ul class="salon-promo__extras">
      <li class="salon-promo__extras-item" v-for="extra in extras" :key="extra">{{ extra }}</li>
    </ul>

  </section>
</template>


<script>

export default {
  data(){
    return{
      extras: [
        "Shampoo",
        "Scalp Massage",
        "Treatments",
        "Blow Dry",
        "Beard Trim"
      ]
    }
  }
}
</script>
